import { create } from 'zustand';

interface SelectedMoviesStore {
  // State
  selectedMovieIds: Set<string>;
  
  // Actions
  toggleMovieSelection: (movieId: string) => void;
  selectAllMovies: (movieIds: string[]) => void;
  clearSelection: () => void;
  isMovieSelected: (movieId: string) => boolean;
  getSelectedCount: () => number;
  getSelectedIds: () => string[];
}

export const useSelectedMoviesStore = create<SelectedMoviesStore>()((set, get) => ({
  // Initial state
  selectedMovieIds: new Set<string>(),

  // Actions
  toggleMovieSelection: (movieId: string) => {
    set((state) => {
      const newSelectedIds = new Set(state.selectedMovieIds);
      if (newSelectedIds.has(movieId)) {
        newSelectedIds.delete(movieId);
      } else {
        newSelectedIds.add(movieId);
      }
      return { selectedMovieIds: newSelectedIds };
    });
  },

  selectAllMovies: (movieIds: string[]) => {
    set({ selectedMovieIds: new Set(movieIds) });
  },

  clearSelection: () => {
    set({ selectedMovieIds: new Set<string>() });
  },

  isMovieSelected: (movieId: string) => {
    return get().selectedMovieIds.has(movieId);
  },

  getSelectedCount: () => {
    return get().selectedMovieIds.size;
  },

  getSelectedIds: () => {
    return Array.from(get().selectedMovieIds);
  }
}));